import { create } from "zustand";
import { persist } from "zustand/middleware";

type ComplexesStore = {
  complexesView: "grid" | "list";
  setComplexesView: (view: "grid" | "list") => void;

  upcomingEventsView: "calendar" | "list";
  setUpcomingEventsView: (view: "calendar" | "list") => void;
};

export const useComplexesStore = create<ComplexesStore>()(
  persist(
    (set) => ({
      complexesView: "grid",
      setComplexesView: (complexesView) => set({ complexesView }),

      upcomingEventsView: "list",
      setUpcomingEventsView: (upcomingEventsView) =>
        set({ upcomingEventsView }),
    }),
    {
      name: "complexes-preferences",
      version: 1,
      migrate: (state: unknown, version: number) => {
        const s = state as Record<string, unknown>;
        if (version === 0 && s?.upcomingEventsView === "calendar") {
          s.upcomingEventsView = "list";
        }
        return s;
      },
    },
  ),
);
